import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";

import EmployeeForm from "../../helpers/EmployeeForm";

import { Box, Card, Chip, Tab, Tabs, Tooltip } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import moment from "moment";
import RequestDialog from "../../helpers/RequestDialog";
import a11yProps from "../../helpers/ay-props";
import { useHistory, useLocation } from "react-router-dom";
import StaffPositionComponent from "../../components/Settings/StaffPosition";
import CichiinEmployeeComponent from "./CichiinEmployeeComponent";

const statuses = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Departed",
    value: "quit",
  },
];

export function Resource({
  technologies,
  GetTechnologies,
  // institutions,
  loggedUser,
  SetSelectedMenu,
  FetchDetails,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;

  const location = useLocation(); // Get the state passed from EmployeesManagement
  const history = useHistory(); // Initialize useHistory
  const [tabValue, setTabValue] = React.useState(location.state?.tab || 1); // Default to Employees tab
  const [statusTab, setStatusTab] = React.useState(0); // Default to "Active" tab

  const [open, setOpen] = React.useState(0);
  const [openStatus, setOpenStatus] = React.useState(0);
  const [value, setValue] = React.useState({});

  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [languages, setLanguages] = React.useState(null);
  const [count, setCount] = React.useState(0);
  const [positions, setPositions] = React.useState([]);
  const [levels, setLevels] = React.useState([]);
  const [institutions, setInstitutions] = React.useState([]);
  const [period, setPeriod] = React.useState({
    startDate: null,
    endDate: null,
  });
  const [selectedPosition, setSelectedPosition] = React.useState("");
  const [selectedContractType, setSelectedContractType] = React.useState("");
  const [employeeFormOpen, setEmployeeFormOpen] = React.useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 0) {
      history.push("/admin/if-structure", { state: { tab: 0 } }); // Navigate back to EmployeesManagement
    }
  };

  const handleStatusTabChange = (event, newValue) => {
    setStatusTab(newValue); // Switch between "Active" and "Departed"
  };

  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions(positionList);
    }
  };

  // load all instutions
  const loadInstitutions = async () => {
    const resp = await FetchDetails(`/api/institutions`);
    if (resp.status) {
      const institutionList = resp?.data?.data?.map((item) => ({
        value: item.id,
        label: item.institutionName,
      }));
      setInstitutions(institutionList);
    }
  };

  const loadlevels = async () => {
    const resp = await FetchDetails("/api/division");
    if (resp.status) {
      const levelList = resp?.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setLevels(levelList);
    }
  };

  const columns = [
    {
      name: "names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "phone",
      label: "Phone No",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "positionName",
      label: "Position",
    },
    {
      name: "structureName",
      label: "Structure",
    },
    {
      name: "entryDate",
      label: "Tenure",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (v) => {
          if (!v) {
            return "";
          }
          const now = moment(new Date());
          const entryDate = moment(v);
          const duration = moment.duration(now.diff(entryDate));

          const years = duration.years();
          const months = duration.months();
          const days = duration.days();
          const hours = duration.hours();

          let formattedDuration = "";
          if (years > 0) {
            formattedDuration = `${years}y ${months > 0 ? `${months}m` : ""}`.trim();
          } else if (months > 0) {
            formattedDuration = `${months}m ${days > 0 ? `${days}d` : ""}`.trim();
          } else if (days > 0) {
            formattedDuration = `${days}d ${hours > 0 ? `${hours}h` : ""}`.trim();
          } else {
            formattedDuration = `${hours}h`;
          }
          return (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                  },
                },
              }}
              title={moment(v).format("YYYY-MMM-DD hh:mm:ss")}
            >
              <Chip size={"small"} label={formattedDuration} />
            </Tooltip>
          );
        },
      },
    },
    {
      name: "projectsAssigned",
      label: "Projects Assigned",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (v) => {
          // if (!v || v === 0) {
          //   return <span className="text-gray-500">No Projects</span>;
          // }
          return (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                  },
                },
              }}
              title={`${v} Project${v > 1 ? "s" : ""}`}
            >
              <Chip size={"small"} label={v} />
            </Tooltip>
          );
        },
      },
    },


    {
      name: "lastLogin",
      label: "Last Login",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (v) => {
          if (!v) {
            return "";
          }
          const diff = moment(new Date()).diff(v, "day");
          if (diff <= 2) {
            return (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "white",
                      boxShadow:
                        "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                      color: "black",
                    },
                  },
                }}
                title={moment(v).format("YYYY-MMM-DD hh:mm:ss")}
              >
                <Chip
                  size={"small"}
                  color={"warning"}
                  label={moment(v).fromNow()}
                />
              </Tooltip>
            );
          } else {
            return (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "white",
                      boxShadow:
                        "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                      color: "black",
                    },
                  },
                }}
                title={moment(v).format("YYYY-MMM-DD hh:mm:ss")}
              >
                <Chip size={"small"} label={moment(v).fromNow()} />
              </Tooltip>
            );
          }
        },
      },
    },
    {
      name: "id",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const obj = list.find((vx) => vx.id === v);
          const request = obj?.Requests?.length > 0 ? obj?.Requests[0] : null;

          const status = obj?.status;

          return (
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                  },
                },
              }}
              title={
                request &&
                request?.status === "approved" &&
                moment(request?.endDate).isAfter(new Date()) && (
                  <div className="flex flex-wrap p-2 bg-white h-42">
                    <div className="flex flex-col">
                      <div className="flex gap-2">
                        <span className="font-semibold">Start Date:</span>
                        <span>
                          {moment(request?.startDate).format("YYYY-MMM-DD")}
                        </span>
                      </div>
                      <div className="flex gap-2">
                        <span className="font-semibold">Return Date:</span>
                        <span>
                          {moment(request?.endDate).format("YYYY-MMM-DD")}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              }
            >
              {(request &&
                request?.status === "approved" &&
                moment(request?.endDate).isAfter(new Date())) ||
                obj?.status === "on-leave" ||
                obj?.status === "on leave" ? (
                <Chip
                  sx={{ backgroundColor: "#FFA400", color: "white" }}
                  label={"on leave"}
                />
              ) : (
                <Chip
                  sx={{
                    backgroundColor:
                      status === "completed" ||
                        status === "active" ||
                        status === "paid"
                        ? "green"
                        : status === "canceled" ||
                          status === "overdue" ||
                          status === "deleted" ||
                          status === "quit" ||
                          status === "denied" ||
                          "departed"
                          ? "#8B0000"
                          : status === "not yet started" ||
                            status === "in progress" ||
                            status === "in-progress"
                            ? "#FFA400"
                            : status === "to-do"
                              ? "#3895D3"
                              : status === "incoming" || status === "upcoming"
                                ? "#ADD8E6"
                                : status === "on-leave"
                                  ? "#FFA400"
                                  : "",
                    color:
                      status === "completed" ||
                        status === "active" ||
                        status === "paid"
                        ? "white"
                        : status === "canceled" ||
                          status === "overdue" ||
                          status === "deleted" ||
                          status === "quit" ||
                          status === "denied" ||
                          "departed"
                          ? "white"
                          : status === "not yet started" ||
                            status === "in progress" ||
                            status === "in-progress"
                            ? "white"
                            : status === "to-do"
                              ? "white"
                              : status === "on-leave"
                                ? "white"
                                : "",
                  }}
                  label={obj?.status === "quit" ? "Departed" : obj?.status}
                />
              )}
            </Tooltip>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            extra={[
              {
                label: "Change Status",
                onClick: () => {
                  setOpenStatus(1);
                  const obj = list.find((vx) => vx.id === v);
                  setValue0("status", obj.status);
                  setId(v);
                },
              },
            ]}
          />
        ),
      },
    },
  ];

  useEffect(() => {
    GetTechnologies();
    loadlevels();
    loadPositions().then();
  }, [GetTechnologies]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "resource",
      title: "Employee Management",
    });
  }, []);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const onSuccess = () => setCount((v) => v + 1);


  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/resource/delete/${id}`}
      />
      <ResourceFormDialog
        master={loggedUser?.allowResource}
        onSuccess={onSuccess}
        setOpen={setOpen}
        open={open}
        id={id}
        technologies={technologies}
        positions={positions}
        levels={levels}
        setValue0={setValue0}
        value={value}
      />
      <FormDialog
        maxWidth={"sm"}
        open={openStatus > 0}
        onSuccess={onSuccess}
        setOpen={setOpenStatus}
        url={`/api/resource/change/status/${id}`}
        title={"Change Status"}
        fields={[
          {
            name: "status",
            label: "Status",
            type: "select",
            values: statuses,
            value: value["status"],
            required: true,
            setValue: (val) => setValue0("status", val),
          },
        ]}
      />
      <RequestDialog
        open={languages !== null}
        url={`/api/resource/technologies/${languages}`}
        setOpen={() => setLanguages(null)}
        render={(lang) => {
          return lang?.list?.map((v) => (
            <Chip
              size={"small"}
              className={"mr-1"}
              label={v.Technology?.name}
            />
          ));
        }}
      />

      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                borderRadius: "10px",
                backgroundColor: mainBackground,
              },
            }}
          >
            <Tab
              label="Structure"
              style={{
                marginLeft: "10px",
                marginBottom: "10px",
                marginTop: "10px",
                borderRadius: "10px",
                backgroundColor: tabValue === 0 ? mainBackground : "transparent",
                color: tabValue === 0 ? "white" : "black",
              }}
              {...a11yProps(0)}
            />

            <Tab
              label="Employees"
              style={{
                marginLeft: "10px",
                marginBottom: "10px",
                marginTop: "10px",
                borderRadius: "10px",
                backgroundColor: tabValue === 1 ? mainBackground : "transparent",
                color: tabValue === 1 ? "white" : "black",
              }}
              {...a11yProps(1)}
            />
            <Tab
              label="Positions"
              style={{
                marginLeft: "10px",
                marginBottom: "10px",
                marginTop: "10px",
                borderRadius: "10px",
                backgroundColor: tabValue === 2 ? mainBackground : "transparent",
                color: tabValue === 2 ? "white" : "black",
              }}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <hr style={{ border: "0.5px solid #ccc", margin: "10px 0" }} />
        {tabValue === 3 && (
          <DatatableComponent
            viewColumns={false}
            searchfield={true}
            search={false}
            hideToolbar={false}
            onRowClick={(data, { rowIndex }) => {
              history.push(`/admin/profile/${list[rowIndex].id}`);
            }}
            onAddNew={() => setEmployeeFormOpen(true)}
            // processData={(data) => {
            //   setList(data.data);
            //   return data;
            // }}

            processData={(data) => {
              const processedData = data.data.map((item) => {
                const division = item.Division?.name;
                const department = item.Department?.name;
                const office = item.Office?.name;
                const institution = item.Institution?.institutionName;

                // Add a computed "Structure" field
                item.Structure =
                  division || department || office || institution || " ";
                return item;
              });

              setList(processedData); // Update the list state
              return { ...data, data: processedData };
            }}
            elevation={1}
            columns={columns}
            url={`/api/resource/list?count=${count}&status=${statusTab === 0 ? "active" : "quit"
              }&assigned=${location.state?.assigned ?? ""}&category=${location.state?.category ?? ""
              }&year=${location.state?.year ?? ""}&startDate=${period.startDate
              }&endDate=${period.endDate
              }&positionId=${selectedPosition}&type=${selectedContractType}`}
            title={
              <div className="flex items-center justify-between">
                {/* Left: Active and Departed Tabs */}
                <Tabs
                  value={statusTab}
                  onChange={handleStatusTabChange}
                  aria-label="status tabs"
                  TabIndicatorProps={{
                    style: {
                      borderRadius: "10px",
                      backgroundColor: mainBackground,
                    },
                  }}
                >
                  <Tab
                    label="Active"
                    style={{
                      marginLeft: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      borderRadius: "10px",
                      backgroundColor:
                        statusTab === 0 ? mainBackground : "transparent",
                      color: statusTab === 0 ? "white" : "black",
                    }}
                    {...a11yProps(0)}
                  />
                  <Tab
                    label="Departed"
                    style={{
                      marginLeft: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      borderRadius: "10px",
                      backgroundColor:
                        statusTab === 1 ? mainBackground : "transparent",
                      color: statusTab === 1 ? "white" : "black",
                    }}
                    {...a11yProps(1)}
                  />
                </Tabs>
              </div>
            }
          />
        )}
        {tabValue === 1 && <CichiinEmployeeComponent />}

        {tabValue === 2 && <StaffPositionComponent />}

      </Card>
      <EmployeeForm
        open={employeeFormOpen ? 1 : 0}
        setOpen={setEmployeeFormOpen}
        onSuccess={() => setCount((v) => v + 1)}
        levels={levels}
        technologies={technologies}
        value={{}}
        setValue0={() => { }}
        master={loggedUser?.allowResource}
      />
    </div>
  );
}

export const ResourceFormDialog = ({
  onSuccess,
  setOpen,
  open,
  id,
  positions,
  setValue0,
  value,
  loadingDepartments,
  loadingOffices,
  loadingDivisions,
}) => {
  return (
    <FormDialog
      maxWidth={"md"}
      open={open > 0}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/create" : `/api/resource/update/${id}`}
      title={open === 1 ? "Create New Employee" : "Allocate Employee"}
      fields={[
        {
          name: "names",
          label: "Names",
          type: "text",
          value: value["names"],
          required: true,
          setValue: (val) => setValue0("names", val),
        },
        {
          name: "positionId",
          label: "Position",
          type: "select",
          values: positions,
          value: value["positionId"],
          required: true,
          setValue: (val) => setValue0("positionId", val),
        },

        // {
        //   name: "institutionId",
        //   label: "Institution",
        //   type: "select",
        //   values: institutions,
        //   value: value["institutionId"],
        //   required: true,
        //   // setValue: (val) => setValue0("institutionId", val),
        //   setValue: (val) => {
        //     setValue0("institutionId", val);
        //   },
        // },
        // {
        //   name: "officeId",
        //   label: "Office",
        //   type: "select",
        //   values: loadingOffices
        //     ? [{ label: "Loading...", value: "" }]
        //     : offices,
        //   value: value["officeId"],
        //   setValue: (val) => setValue0("officeId", val),
        // },
        // {
        //   name: "departmentId",
        //   label: "Department",
        //   type: "select",
        //   values: loadingDepartments
        //     ? [{ label: "Loading...", value: "" }]
        //     : departments,
        //   value: value["departmentId"],
        //   setValue: (val) => setValue0("departmentId", val),
        // },
        // ...(divisions.length > 0
        //   ? [
        //       {
        //         name: "divisionId",
        //         label: "Division",
        //         type: "select",
        //         values: loadingDivisions
        //           ? [{ label: "Loading...", value: "" }]
        //           : divisions,
        //         value: value["divisionId"],
        //         setValue: (val) => setValue0("divisionId", val),
        //       },
        //     ]
        //   : []),
        {
          name: "cv",
          label: "C.V (Attachment)",
          type: "file-drag",
          value: value["cv"],
          setValue: (val) => setValue0("cv", val),
          hidden: true,
        },
      ]}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Resource);
